import React, { useEffect } from 'react';
import { handleGoogleCallback } from '../services/google';

const GoogleCallback = () => {
  useEffect(() => {
    handleGoogleCallback();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-dark-200">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto mb-4"></div>
        <p className="text-gray-600 dark:text-gray-400">Google ile giriş yapılıyor...</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
